module.exports = __webpack_public_path__ + "static/media/log-viewer-grey.3e00f2b2.svg";